var _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 90,
    viewBox: "0 0 52 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 26,
    cy: 68,
    r: 22,
    fill: "#00A6A6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 68,
    r: 4,
    fill: "#00A6A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6364 10.4836C20.9097 4.83103 31.0903 4.83103 38.3636 10.4836C46.2104 16.5819 48.4387 27.4908 43.6119 36.1778L35.4697 50.8318C31.342 58.2607 20.658 58.2607 16.5303 50.8318L8.38808 36.1778C3.56131 27.4908 5.78958 16.5819 13.6364 10.4836Z",
    fill: "#00A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3834 22.975L27.6084 18.3583C26.7167 17.6416 25.2751 17.6416 24.3917 18.35L18.6167 22.975C17.9667 23.4916 17.5501 24.5833 17.6917 25.4L18.8001 32.0333C19.0001 33.2166 20.1334 34.175 21.3334 34.175H30.6667C31.8584 34.175 33.0001 33.2083 33.2001 32.0333L34.3084 25.4C34.4417 24.5833 34.0251 23.4916 33.3834 22.975ZM26.0001 28.9166C24.8501 28.9166 23.9167 27.9833 23.9167 26.8333C23.9167 25.6833 24.8501 24.75 26.0001 24.75C27.1501 24.75 28.0834 25.6833 28.0834 26.8333C28.0834 27.9833 27.1501 28.9166 26.0001 28.9166Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.b35b36bc6dd3e53802dd617889eb3f06.svg";
export { ForwardRef as ReactComponent };